var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3334_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.65 16C30.65 7.9078 24.0902 1.35 16 1.35C7.90783 1.35 1.35 7.90786 1.35 16C1.35 24.0903 7.90777 30.65 16 30.65C24.0903 30.65 30.65 24.0903 30.65 16Z",
    fill: "#C6DDFF",
    stroke: "#002356",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8685 19.379V21.4396C22.8693 21.6309 22.8301 21.8203 22.7535 21.9955C22.6769 22.1708 22.5645 22.3281 22.4235 22.4575C22.2825 22.5868 22.1161 22.6852 21.9349 22.7465C21.7537 22.8078 21.5617 22.8306 21.3712 22.8133C19.2575 22.5837 17.2273 21.8614 15.4435 20.7047C13.7839 19.6501 12.3768 18.243 11.3223 16.5835C10.1614 14.7916 9.43904 12.7514 9.21358 10.6283C9.19642 10.4384 9.21899 10.2469 9.27987 10.0662C9.34074 9.88544 9.43858 9.71936 9.56716 9.5785C9.69574 9.43765 9.85224 9.32511 10.0267 9.24805C10.2011 9.17099 10.3897 9.13111 10.5805 9.13093H12.6411C12.9744 9.12765 13.2976 9.24569 13.5503 9.46305C13.8031 9.68041 13.9681 9.98226 14.0148 10.3123C14.1018 10.9718 14.2631 11.6193 14.4956 12.2424C14.588 12.4883 14.608 12.7555 14.5532 13.0123C14.4985 13.2692 14.3712 13.505 14.1865 13.6917L13.3142 14.5641C14.292 16.2837 15.7158 17.7075 17.4354 18.6853L18.3077 17.8129C18.4945 17.6283 18.7303 17.501 18.9871 17.4462C19.244 17.3914 19.5112 17.4114 19.757 17.5039C20.3802 17.7364 21.0277 17.8977 21.6871 17.9847C22.0208 18.0317 22.3255 18.1998 22.5433 18.4569C22.7612 18.714 22.8769 19.0421 22.8685 19.379Z",
    fill: "#FFCCAA",
    stroke: "#002356",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3334_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.8a2139ea9461caae6849bbadb45fab5f.svg";
export { ForwardRef as ReactComponent };